import axios from 'axios'
import { format } from 'date-fns'

export async function setSelectedDates(selectedDate: Date, isSelected: boolean, factory_id: number, headers: any): Promise<any[]> {
  if (isSelected) {
    const branchData = {}
    return axios.post(`/v0/factories/${factory_id}/factory-closed-dates`, branchData, {
      headers: headers,
      params: { date: format(selectedDate, 'yyyy-MM-dd') }
    }).then((res) => res.data)
  } else {
    return axios.delete(`/v0/factories/${factory_id}/factory-closed-dates`, {
      headers: headers,
      params: { date: format(selectedDate, 'yyyy-MM-dd') }
    }
    ).then((res) => res.data)
  }
}
